import { makeStyles } from '@mui/styles';

export const muiMenuStyles = makeStyles({
    paper: {
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important', // Tailwind's shadow-md
        borderRadius: '0.375rem !important', // Tailwind's rounded-md (6px)
    },
});